/* eslint-disable */
import {FavouritesListviewProduct} from './FavouritesListviewProduct';
import {ProductlistViewProduct} from './ProductlistViewProduct';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.src.views.FavouritesPage.FavouritesPageModel
*/
export interface FavouritesPageModel extends BasePageModel {
	favouritesList?: FavouritesListviewProduct[];
	basedOnFavourites?: ProductlistViewProduct[];
}
export const isFavouritesPage = (model: unknown): model is FavouritesPageModel => (model as FavouritesPageModel).componentName === 'FavouritesPage';
